var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "US.b94ab528.png","uri@2x": __webpack_public_path__ + "US.44bc7fb0.png","uri@3x": __webpack_public_path__ + "US.99efd92b.png",
    width: 42,
    height: 30
});